import { useHistory, useLocation } from 'react-router-dom';
import useAccessKey from './useAccessKey';
import { SelectTrainingPageState } from './useSelectTraining';
import { PAGE_PATH_NAME } from '../utils/const';

type UseCheckTransitionValue = {
  // 遷移を許可するか
  allowTransition: () => boolean;
};

const useCheckTransition = (): UseCheckTransitionValue => {
  const { accessKey } = useAccessKey();
  const history = useHistory();
  const { pathname, state } = useLocation();

  /**
   * トレーニング画面に渡されたstateの中身を判定
   * @returns stateの中身があるかどうか
   */
  const containsSelectTrainingState = (): boolean => {
    if (state === undefined) {
      return false;
    }

    // unknown型のため型アサーションしてプロパティを確認
    const selectTrainingPageState = state as SelectTrainingPageState;
    if (
      selectTrainingPageState.trainingId &&
      selectTrainingPageState.contents
    ) {
      return true;
    }

    return false;
  };

  /**
   * 遷移を許可するか
   * @returns YES:遷移を許可する / NO:遷移を許可しない
   */
  const allowTransition = (): boolean => {
    // ログオン状態チェック
    if (!accessKey) {
      history.replace(PAGE_PATH_NAME.SERIAL_INPUT);

      return false;
    }

    if (pathname === PAGE_PATH_NAME.LESSON) {
      // ログオン状態かつ遷移元、遷移先画面がlessonの場合、画面遷移しない
      return true;
    }

    // URL直打ちチェック
    if (pathname === PAGE_PATH_NAME.TRAINING && containsSelectTrainingState()) {
      return true;
    }

    history.replace(PAGE_PATH_NAME.LESSON);

    return true;
  };

  return {
    allowTransition,
  };
};
export default useCheckTransition;
